import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { CONTACT } from "../lib/data";

export const WhatsAppButton = () => (
  <motion.a
    data-testid="whatsapp-cta"
    href={`https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(
      "Halo YLBH Sumatera Timur, saya ingin berkonsultasi mengenai masalah hukum."
    )}`}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Hubungi kami via WhatsApp"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 1.6, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.94 }}
    className="group fixed bottom-6 right-6 z-50 flex items-center gap-0 overflow-hidden border border-gold/40 bg-[#121212]/90 py-3.5 pl-4 pr-4 shadow-2xl backdrop-blur-md transition-colors duration-300 hover:border-gold hover:bg-gold"
  >
    <MessageCircle
      size={22}
      className="shrink-0 text-gold transition-colors duration-300 group-hover:text-ink"
    />
    <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-medium text-white transition-all duration-500 group-hover:ml-3 group-hover:max-w-[180px] group-hover:text-ink">
      Chat WhatsApp
    </span>
  </motion.a>
);
